module.exports = __webpack_public_path__ + "static/media/mobile-app-google-play-image.b5987edc.png";